import { IUserNotifyEventsType, IUserNotifyType, IUserSocietyFilterType } from '@shared/models/IUser';
import { BasicUser } from '@shared/models/user';
import { IndexResponse } from '@shared/types/services';

export enum UserRoles {
  // General
  Assignee = 0,
  Invitee = 1,
  JointAgent = 2,
  Owner = 3,
  PAAdministrator = 8,
  PermittedUser = 9,
  // Transaction
  TenantAgent = 4,
  LandlordAgent = 5,
  PurchaserAgent = 6,
  VendorAgent = 7,
}

export enum UserNotifyTenure {
  Both = 'both',
  Lettings = 'lettings',
  Sales = 'sales',
}

// ---- User - Item ----

// ---- User - Queries ----

// List
export const usersListFilterGroupKeys = [['created_from', 'created_to']];

export const usersListFilterParamKeys = [
  ...usersListFilterGroupKeys.flat(),
  'email',
  'name',
  'societies',
  'status',
  'teams',
] as const;

export const usersListParamsKeys = [...usersListFilterParamKeys, 'limit', 'page', 'search'] as const;

export type UsersListParams = PartialQuery<typeof usersListFilterParamKeys>;

export type UsersListPayload = QueryPayload<UsersListParams>;

export type UsersListResponse = IndexResponse<BasicUser>;

// ---- User - Mutations ----

export type UsersUpdateProfileImageDTO = FormData;

export interface UsersUpdateProfileImagePayload extends BodyPayload<UsersUpdateProfileImageDTO> {
  id: string;
}

export interface UserUpdateDTO {
  company: string;
  email: string;
  forename: string;
  leases_eg_leaderboard_region: string;
  linkedin: string;
  mobile_number: string;
  phone_number: string;
  position: string;
  sales_eg_leaderboard_region: string;
  surname: string;
  twitter: string;
  view_interest_with_requirement_enabled: boolean;
  visible_interest_fields: string[];
  visible_requirement_fields: string[];
}

export interface UserUpdatePayload extends BodyPayload<Partial<UserUpdateDTO>> {
  id: number;
}

export interface UserUpdateNotificationsDTO {
  //Acquisitions Notifications
  notify_acquisitions_type: IUserNotifyType;
  notify_acquisitions_criteria_building_types: string; // ids string
  notify_acquisitions_criteria_max_size: number | null;
  notify_acquisitions_criteria_min_size: number | null;
  notify_acquisitions_criteria_submarkets: number[];
  notify_acquisitions_where_desktop: NumberBoolean;
  notify_acquisitions_where_email: NumberBoolean;
  notify_acquisitions_where_mobile: NumberBoolean;

  //Disposals Notifications
  notify_disposals_type: IUserNotifyType;
  notify_disposals_tenure: UserNotifyTenure;
  notify_disposals_criteria_building_types: string;
  notify_disposals_criteria_max_size: number | null;
  notify_disposals_criteria_min_size: number | null;
  notify_disposals_criteria_submarkets: number[];
  notify_disposals_where_desktop: NumberBoolean;
  notify_disposals_where_email: NumberBoolean;
  notify_disposals_where_mobile: NumberBoolean;

  //Events Notifications
  notify_events_type: IUserNotifyEventsType;
  notify_events_where_desktop: NumberBoolean;
  notify_events_where_email: NumberBoolean;
  notify_events_where_mobile: NumberBoolean;

  //Filter Acquisitions
  filter_acquisitions_type: IUserSocietyFilterType;
  filter_acquisitions_max_size: number | null;
  filter_acquisitions_min_size: number | null;
  filter_acquisitions_submarkets: number[];

  //Filter Disposals
  filter_disposals_type: IUserSocietyFilterType;
  filter_disposals_max_size: number | null;
  filter_disposals_min_size: number | null;
  filter_disposals_submarkets: number[];

  //Other Notifications
  system_notifications_match_comments: NumberBoolean;
  system_notifications_match_request_sent_bcc_on_my_disposals: NumberBoolean;
  system_notifications_match_request_sent_joint_agents: NumberBoolean;
  system_notifications_match_request_sent_notify_team: NumberBoolean;
  system_notifications_pending_match_requests_reminders: NumberBoolean;
}

export interface UserUpdateNotificationsPayload extends BodyPayload<Partial<UserUpdateNotificationsDTO>> {
  id: number;
}

export interface UsersUpdateProfileImageResponse {
  url: string;
}

export interface UserUpdatePaswordDTO {
  current_password: string;
  password: string;
  password_confirmation: string;
}

export interface UserUpdatePasswordPayload extends BodyPayload<Partial<UserUpdatePaswordDTO>> {
  id: number;
}
